module.exports = __webpack_public_path__ + "static/media/2.d92e8276.JPG";